export default __webpack_public_path__ + "static/media/section2-img2.bd193437.png";